export default __webpack_public_path__ + "static/media/icon-moon.83b9f0db.svg";